import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({

  header: {
    fontSize: 35,
    fontWeight: 700,
    color: '#335977',
    margin: theme.spacing(0),
'@media (max-width: 1200px)': {
    fontSize: 18,
    }
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
 '@media (max-width: 1050px)': {
    width:'25%'
    },
 '@media (max-width: 850px)': {
    width:'100%'
    }
  }
}));

const PageHeader = props => {
  const classes = useStyles();
  const { text, className = '', name = '' } = props;
  const classname = className ? clsx(classes.header, className) : classes.header;
  return (
    <div className={classes.headerWrapper}>
      <Typography id={name} className={classname} variant="h5" component="h5">
        {text}
      </Typography>
      {props.tools}
    </div>
  );
};

export default PageHeader;
